/**
 * Copyright © Veeam Software Group GmbH.
 */

import { BackupAgentOperationModeRepresentation } from '@veeam-vspc/models/web-controllers';

export type VawOperationModes = BackupAgentOperationModeRepresentation;
export const VawOperationModes = BackupAgentOperationModeRepresentation;
